// Install and load fonts
import "@fontsource/ibm-plex-sans/300.css";
import "@fontsource/ibm-plex-sans/400.css";
import "@fontsource/ibm-plex-sans/500.css";
import "@fontsource/ibm-plex-sans/700.css";
import { createRoot } from "react-dom/client";
import "./index.css";
import CssBaseline from "@mui/material/CssBaseline";
import { AuthProvider } from "react-oidc-context";
import { oidcConfig } from "shared/auth/oidc";
import App from "./features/App";

const container = document.getElementById("root");
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);

function onSigninCallback() {
  // removing the state url parameter from the URL on successful login
  window.location.href = "/";
}

root.render(
  <AuthProvider {...oidcConfig} onSigninCallback={onSigninCallback}>
    {/* CSS reset for cross-browser design consistency */}
    <CssBaseline />
    <App />
  </AuthProvider>
);
